const en = {
  text: 'Open the bias in UX Core',
  tip: 'will open in a new tab',
};

export default en;
